import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private nav: Router, private loc: Location) {}

  goBack(fallbackUrl: string = '/'): void {
    // If can go back, navigate back
    if (this.canGoBack()) {
      this.loc.back();
    }
    // Otherwise, navigate to the fallback URL
    else {
      this.nav.navigate([fallbackUrl], { replaceUrl: true });
    }
  }

  canGoBack(): boolean {
    // Checks if there's a history to navigate back to
    return (
      !!window.history.state?.navigationId &&
      window.history.state.navigationId > 1
    );
  }
}
